/* global GOOGLE_MAPS_API_KEY */

let loaderPromise = null

export function loadGoogleMaps() {
  if (window.google?.maps?.Map) { return Promise.resolve(window.google.maps) }

  // Re-use the same promise for every consumer.
  if (loaderPromise) { return loaderPromise }

  loaderPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector('script[data-gmap]')
    if (existing) {
      // If script exists but API not ready, listen for load event.
      if (!window.google?.maps?.Map) {
        existing.addEventListener('load', () => resolve(window.google.maps))
        return
      }
      return resolve(window.google.maps)
    }

    const script = document.createElement('script')
    script.setAttribute('data-gmap', 'jsapi')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&libraries=marker,geometry&loading=async`
    script.async = script.defer = true

    script.onload = () =>
      window.google?.maps ? resolve(window.google.maps)
        : reject(new Error('Google Maps failed to load'))
    script.onerror = reject
    document.head.appendChild(script)
  })

  return loaderPromise
}
